
var config = require("app/util/config/config");

var Social = React.createClass({
  render: function () {
    return (
      <div>
        <SocialLink href={this.props.data.facebook} title={this.props.data.facebook} type="facebook"/>
        <SocialLink href={this.props.data.twitter} title={this.props.data.twitter} type="twitter"/>
        <SocialLink href={this.props.data.linked_in} title={this.props.data.linked_in} type="linked_in"/>
        <SocialLink href={this.props.data.skype} title={this.props.data.skype} type="skype" />
      </div>
    );
  }
});

var SocialLink = React.createClass({
  getImageURL: function () {
    var url = "";
    switch (this.props.type) {
      case "facebook":
        url = config.app.webAppURL + "/images/facebook.png"; break;
      case "twitter":
        url = config.app.webAppURL + "/images/twitter.png"; break;
      case "linked_in":
        url = config.app.webAppURL + "/images/linkedin.png"; break;
      case "skype":
        url = config.app.webAppURL + "/images/skype.png"; break;
    }
    return url;
  },
  formatHref: function () {
    if (this.props.type == "skype") {
      return "skype:"+this.props.href+"?call";
    } else {
      return "http://" + this.props.href;
    }
  },
  getHref: function () {
    if (this.props.href) {
      return this.formatHref();
    } else {
      return "#";
    }
  },
  render: function () {
    // when there is no link set
    if (this.getHref() == "#") {
      // show disable link
      return (
        <a disabled="true" href={this.getHref()} target="_blank" title={this.props.title} className="social-link">
          <img src={this.getImageURL()}/>
        </a>
      );
    } else {
      return (
        <a href={this.getHref()} target="_blank" title={this.props.title} className="social-link">
          <img src={this.getImageURL()}/>
        </a>
      );
    }
  }
});

module.exports = Social;



// WEBPACK FOOTER //
// ./app/shared/components/Hover/social.jsx